import "./resource";

export class TranslationsService {
    public static $inject: string[] = ["$log", "$q", "translationsResource"];

    constructor(private $log: ng.ILogService, private $q: ng.IQService, private translationsResource) {}

    public getConfig() {
        return this.translationsResource().getConfig().$promise;
    }

    public postTranslations(id) {
        return this.translationsResource()
            .postSaleTranslations({ id })
            .$promise.catch(error => {
                this.$log.error(`Error while post sale translations ${id}`, error);
                return this.$q.reject(error);
            });
    }
}

angular
    .module("thor.core.translations.service", ["thor.core.translations.resource"])
    .service("translationsService", TranslationsService);
